import { render } from "./PaidTipsExplainer.vue?vue&type=template&id=c2146274&scoped=true"
import script from "./PaidTipsExplainer.vue?vue&type=script&lang=js"
export * from "./PaidTipsExplainer.vue?vue&type=script&lang=js"

import "./PaidTipsExplainer.vue?vue&type=style&index=0&id=c2146274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2146274"]])

export default __exports__